import { createSlice } from '@reduxjs/toolkit';
import { getAuditLogs } from './thunk';

export const initialState = {
  logs: [],
  nextCursor: undefined,
  hasMore: false,
  loading: false,
  error: {},
};

const auditLogSlice = createSlice({
  name: 'auditLogs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAuditLogs.pending, (state) => {
      state.loading = true;
      state.error = {};
    });
    builder.addCase(getAuditLogs.fulfilled, (state, action: any) => {
      state.logs = action.payload.append ? [...state.logs, ...action.payload.data] : action.payload.data;
      state.nextCursor = action.payload.nextCursor;
      state.hasMore = action.payload.hasMore;
      state.loading = false;
      state.error = {};
    });
    builder.addCase(getAuditLogs.rejected, (state, action: any) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default auditLogSlice.reducer;
